import React from 'react';

import { useNavigateBack } from '../../navigation';

export const useRateOrderNavigation = () => {
  const navigateBack = useNavigateBack();

  return React.useMemo(
    () => ({
      dismissRateOrder: navigateBack,
    }),
    [navigateBack],
  );
};
